import React from 'react';
import { Icon, Popover } from '@material-ui/core';

export default function AdditionalTextPopup({ text, color }: { text: string; color: string }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'text-popover' : undefined;

  return (
    <>
      <div
        aria-describedby={id}
        style={{ display: 'flex', cursor: 'pointer', width: '16px', height: '16px' }}
        onClick={handleClick}
      >
        <Icon style={{ fontSize: '16px', color: '#616161' }}>arrow_downward</Icon>
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <div style={{ color, padding: 12 }}>{text}</div>
      </Popover>
    </>
  );
}
